import { render } from "./videoLibrary.vue?vue&type=template&id=467d9930&scoped=true"
import script from "./videoLibrary.vue?vue&type=script&lang=js"
export * from "./videoLibrary.vue?vue&type=script&lang=js"

import "./videoLibrary.vue?vue&type=style&index=0&id=467d9930&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467d9930"]])

export default __exports__